var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditDatagridIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillOpacity: 0.54,
  d: "M8.333 9H12.5v8.5H8.333zm5.834 8.5h2.5c.916 0 1.666-.75 1.666-1.667V9h-4.166zM12 2.5H4.167C3.25 2.5 2.5 3.25 2.5 4.167v2.5H12V2.5M2.5 15.833c0 .917.75 1.667 1.667 1.667h2.5V8.333H2.5zM13 6.75V8h1.25l3.686-3.686-1.25-1.25zm5.903-3.403c.13-.13.13-.34 0-.47l-.78-.78a.33.33 0 0 0-.47 0l-.61.61 1.25 1.25z"
})));
export { SvgEditDatagridIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/editDatagridIcon.15548dd8.svg";